<template>
  <div class="c-help" v-show="show">
    <r-title>{{ title }}</r-title>
    <r-text>{{ text }}</r-text>
    <el-button class="r-button" @click="show = false">
      Понятно
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: true
    };
  }
};
</script>

<style lang="scss">
.c-help {
  position: absolute;
  padding: 16px;
  left: calc(100% + 16px);
  top: 16px;
  z-index: 1000;
  width: 268px;
  border-radius: 4px;
  background-color: var(--bg_panel_secondary) !important;

  .r-text,
  .r-button {
    margin-top: 16px;
  }
}
</style>
